/*
    provides ability of following a map view area according to moving marker
 */
class mapFollowTheObject {
    constructor(map) {
        this.map = map
        this.mapMovingState = false
    }

    /*
        start map following for geoObject
     */
    startFollowing(geoObject, onInterruptCallback) {
        if (this.followFor != null)
            this.stopFollowing();

        this.followFor = geoObject;

        let latLng = geoObject.getLatLng()
        if (latLng)
            this.map.setView(geoObject.getLatLng());

        //this.map.setView([l.latitude, l.longitude], (zoom ? zoom : this._getZoomForAccuracy(l.accuracy)));

        this.map.on("zoomend", this._followingStopOnLeaveViewArea, this);
        this.map.on("movestart", this._mapMovingStarted, this);
        this.map.on("moveend", this._followingStopOnLeaveViewArea, this);
        this.followFor.on("move", this._followingObjectMove, this);
        this.followFor.once("remove", this.stopFollowing, this);
        this.followingInterruptCallback = onInterruptCallback;
    }

    /*
        stop map following for geoObject
     */
    stopFollowing() {
        //console.log("stop following")
        this.map.off("zoomend", this._followingStopOnLeaveViewArea, this);
        this.map.off("movestart", this._mapMovingStarted, this);
        this.map.off("moveend", this._followingStopOnLeaveViewArea,this);
        if (this.followFor) {
            this.followFor.off("move", this._followingObjectMove, this);
            this.followFor.off("remove", this.stopFollowing, this);
        }
        if (this.followingInterruptCallback)
            this.followingInterruptCallback();
        this.followingInterruptCallback = null;
        this.followFor = null;
    }

    _getZoomForAccuracy(accuracy) {
        if (accuracy < this.requiredAccuracy)
            return 16;
        return 11
    }

    _mapMovingStarted() {
        this.mapMovingState = true
    }
    /*
    check if the following geoObject leave the view area because of a map move or zoom
     */
    _followingStopOnLeaveViewArea() {
        if (! this.followFor)
            return;

        this.mapMovingState = false;

        if (!this._isFollowingObjectOnTheViewArea()) {
            this.stopFollowing();
        }
    }

    /*
        is fired on the marker we are following for
     */
    _followingObjectMove(data) {
        console.log(data.latlng, data.oldLatLng)
        if (! data.oldLatLng) {
            this.map.setView(data.latlng);
        } else {
            let diff = this.map.latLngToLayerPoint(data.latlng).subtract(this.map.latLngToLayerPoint(data.oldLatLng));
            this.map.panBy(diff);
        }
        //console.log("Marker we follow to has changed its position at " + this.geoContext.gpsStateMachine.distance(data.oldLatLng, data.latlng) + " meters and " + `[${diff.x}, ${diff.y}] pixels`);
    }

    _isFollowingObjectOnTheViewArea() {
        if (! this.followFor)
            return false
        return this.map.getBounds().contains(this.followFor.getLatLng())
    }
}

export {mapFollowTheObject};
